import { Link } from '../../widgets/buttons';
import { ZTooltip } from '../../widgets/ztooltip';
import React, { FC } from 'react';
import styled from 'styled-components';
import { T } from '../../../shared/helpers';

export const PageSection = styled.div`
    padding: 20px 40px;
    background-color: #fff;
`;

const Title = styled.h5`
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin: 0px;
    padding-bottom: 16px;
`;

const Description = styled.div`
    padding-bottom: 24px;
`;

const PlatformConnectionContainer = styled.div`
    display: flex;
    box-sizing: border-box;
    padding: 16px;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
    justify-content: flex-start;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.app.primary_light};
    background: #fff;
    cursor: pointer;
`;

const ImageContainer = styled.div`
    display: inline-flex;
    justify-content: center;
    align-items: center;

    img {
        width: auto;
        max-width: 90px;
        height: 36px;
        object-fit: contain;
    }
`;

const PlatformName = styled.span`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
`;

export const Hr = styled.hr`
    padding: 0;
    margin: 24px 0px;
    border: 0;
    height: 0;
    border-top: 1px #ddd solid;
`;

const LearnMore = styled(Link)`
    margin-left: 10px;
    display: inline-block;
`;

export const PlatformItem: FC<{
    title: string;
    image: string;
    name: string;
    zendeskDocId?: string;
    urlToRedirect?: string;
    comingSoon?: boolean;
    disabled?: boolean;
    isMailChimpCallToAction?: boolean;
    onClick: () => void;
}> = (props) => {
    const spanRef = React.useRef<HTMLSpanElement>(null);

    return (
        <ZTooltip title={props.comingSoon ? T._('Coming soon!', 'Admin') : undefined}>
            <PlatformConnectionContainer
                onClick={!props.comingSoon ? props.onClick : () => {}}
                data-track={(!props.comingSoon ? 'standard platform' : 'coming soon platform') + ' ' + props.name}
            >
                <ImageContainer>
                    <img src={`${props.image}`} alt={props.name} />
                </ImageContainer>
                <ZTooltip title={props.name} position='top' isOverflowEnabled={true}>
                    <PlatformName ref={spanRef}>{props.name}</PlatformName>
                </ZTooltip>
            </PlatformConnectionContainer>
        </ZTooltip>
    );
};

interface PlatformConnectionProps {
    title?: string;
    description?: React.ReactNode;
    children?: React.ReactNode;
    learnMoreLabel?: string;
    learnMoreUrl?: string;
}

export const PlatformConnectionSection: FC<PlatformConnectionProps> = ({ title, description, learnMoreLabel, learnMoreUrl, children }) => {
    return (
        <>
            {title && <Title>{title}</Title>}
            {description && (
                <Description>
                    {description}
                    {learnMoreUrl && (
                        <LearnMore href={learnMoreUrl} target='_blank'>
                            {learnMoreLabel ? learnMoreLabel : 'Learn more'}
                        </LearnMore>
                    )}
                </Description>
            )}
            {children}
        </>
    );
};
